import Image from 'next/image';
import {GSSKT_HOST} from '../../../../../config/constants/hosts';
import {
  createFacebookShareUrl,
  createHatenaShareUrl,
  createLineShareUrl,
  createPocketShareUrl,
  createXShareUrl,
} from '../../../../../core/factories/shared/createShareUrl';
import {CommonLink} from '../../../../../shared/components/CommonLink';

type Props = {
  opened: boolean;
  close: () => void;
  currentUrl: string;
  title: string;
};

export const ShareButtonMenu: React.FC<Props> = ({
  opened,
  close,
  currentUrl,
  title,
}) => {
  const shareUrl = `${GSSKT_HOST}${currentUrl}`;

  const services = [
    {
      name: 'Facebook',
      icon: '/next-image/common/sns/Facebook.svg',
      url: createFacebookShareUrl({currentUrl: shareUrl}),
    },
    {
      name: 'X',
      icon: '/next-image/common/sns/X.svg',
      url: createXShareUrl({currentUrl: shareUrl, title}),
    },
    {
      name: 'はてブ',
      icon: '/next-image/common/sns/hatebu.svg',
      url: createHatenaShareUrl({currentUrl: shareUrl}),
    },
    {
      name: 'LINE',
      icon: '/next-image/common/sns/LINE.svg',
      url: createLineShareUrl({currentUrl: shareUrl, title}),
    },
    {
      name: 'Pocket',
      icon: '/next-image/common/sns/Pocket.svg',
      url: createPocketShareUrl({currentUrl: shareUrl, title}),
    },
  ];

  return (
    opened && (
      <>
        <div
          className="h-svh w-svw fixed top-0 left-0 bg-transparent z-50"
          onClick={close}
        />
        <div className="bg-white p-4 shadow-modal w-[190px] rounded-4 absolute bottom-[-198px] left-[-4px] z-50">
          {services.map((service) => (
            <CommonLink
              key={service.url}
              className="flex items-center text-base leading px-12 w-full h-[38px] border-b-[1px] border-line border-collapse [&:nth-last-child(1)]:border-b-[0px] hover:opacity-80"
              href={service.url}
              target="_blank"
            >
              <Image
                src={service.icon}
                width={20}
                height={20}
                alt={`${service.name}でシェア`}
                className="mr-8"
              />
              <p className="text-base text-black-1 leading">{`${service.name}でシェア`}</p>
            </CommonLink>
          ))}
        </div>
      </>
    )
  );
};
